<template>
  <div class="pricing-container">
    <app-navigation></app-navigation>
    <custom-section></custom-section>
  </div>
</template>

<script>
import { useHead } from '@vueuse/head'

import AppNavigation from '../components/navigation'
import CustomSection from '../components/custom-section'

export default {
  name: 'Pricing',
  props: {},
  components: {
    AppNavigation,
    CustomSection,
  },
  setup() {
    // Vue 3 migration: move metaInfo into useHead.
    useHead({
      title: 'Pricing - KORPUS by VLECAD®',
      meta: [
        {
          name: 'description',
          content:
            'KORPUS by VLECAD®: From design to CNC in one click. CAD/CAM that thinks like a craftsman for interior builders and cabinet shops. Book a demo.',
        },
        {
          property: 'og:title',
          content: 'Pricing - KORPUS by VLECAD®',
        },
        {
          property: 'og:description',
          content:
            'KORPUS by VLECAD®: From design to CNC in one click. CAD/CAM that thinks like a craftsman for interior builders and cabinet shops. Book a demo.',
        },
        {
          property: 'og:image',
          content:
            'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/ebedf48f-c2b5-4ca6-808d-9d940905bddf/993061ae-1787-4b73-9fda-47262adc60d9?org_if_sml=1&force_format=original',
        },
      ],
      link: [
        {
          rel: 'canonical',
          href: 'https://hospitable-imperfect-heron-qlicxu.teleporthq.app/pricing',
        },
      ],
    })
  },
}
</script>

<style scoped>
.pricing-container {
  width: 100%;
  display: block;
  min-height: 100vh;
}
</style>
